<template>
	<div class="ReCheckListField">
		<div class="ReCheckListField-input d-flex px-0" style="align-items: center;">
			<el-select
				class="w-100 select-primary overflow-overlay"
				size="large"
				placeholder="Укажите поле "
				filterable
				v-model="bufferValue"
			>
				<el-option
					v-for="(el_opt, el_index) in options"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>

	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReCheckListField',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			counter: String,
			value: [String, Number],
			options:{ 
				type: Array,
				default: function(){return [];},
			},
		},
		data () {
			return {
				ver: 1,
				bufferValue: null,
				suggestView: null,
			}
		},
		watch:{
			
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
			
		},
		computed: {

		},
		methods: {
		},
		mounted(){
			this.bufferValue = this.value?this.$GVO.unlinkObject(this.value):'';
		}
	}
</script>
<style scoped>
</style>
